import React from "react";
import "./../../App.css";
import svetsfilm from "./../../images/svetsfilm.mp4"; // Import the video

export const Home = () => {
  return (
    <div style={{ margin: "0", padding: "0", fontFamily: "Arial, sans-serif", color: "#333" }}>
      {/* Full-width video at the very top */}
      <div style={{ position: "relative", width: "100%", overflow: "hidden" }}>
        <video 
          src={svetsfilm} 
          autoPlay 
          loop 
          muted 
          style={{ width: "100%", height: "auto" }}
        />

        {/* Overlay title on top of the video */}
        <div
          style={{
            position: "absolute",
            top: "30%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "2.5rem", margin: "0", fontWeight: "bold" }}>Välkommen till Elektroteknik</h1>
        </div>
      </div>

      {/* Content below the video */}
      <div style={{ marginTop: "40px", padding: "0 20px", textAlign: "center" }}>
        <h2 style={{ fontSize: "1.8rem", marginBottom: "20px", color: "#004d66" }}>Erfarenhet och expertis inom svetsning och pulverlackering</h2>
        <p style={{ fontSize: "1rem", lineHeight: "1.8", marginBottom: "30px" }}>
          Med mångårig erfarenhet i branschen är vi er pålitliga partner för alla typer av projekt inom svetsning och pulverlackering. 
          Vi anpassar oss helt efter era unika behov och önskemål för att leverera resultat av högsta kvalitet.
        </p>

        <h2 style={{ fontSize: "1.8rem", marginBottom: "20px", color: "#004d66" }}>Våra tjänster – från idé till färdig produkt</h2>
        <p style={{ fontSize: "1rem", lineHeight: "1.8", marginBottom: "20px" }}>
          Vi är engagerade i att hjälpa er genom hela processen, oavsett projektets omfattning. Vårt erbjudande inkluderar:
        </p>
        <ul style={{ textAlign: "left", display: "inline-block", fontSize: "1rem", lineHeight: "1.8", marginBottom: "30px" }}>
          <li><strong>Idé & design:</strong> Vi hjälper er att förverkliga era visioner.</li>
          <li><strong>Konstruktion:</strong> Hållbara och funktionella lösningar.</li>
          <li><strong>Tillverkning:</strong> Produktion enligt era specifikationer.</li>
          <li><strong>Reparation:</strong> Vi återställer funktion och förlänger livslängden.</li>
          <li><strong>Ytbehandling:</strong> Skydd och finish genom blästring och professionell pulverlackering.</li>
        </ul>

        <h2 style={{ fontSize: "1.8rem", marginBottom: "20px", color: "#004d66" }}>Varför välja oss?</h2>
        <ul style={{ textAlign: "left", display: "inline-block", fontSize: "1rem", lineHeight: "1.8", marginBottom: "30px" }}>
          <li><strong>Helhetslösningar:</strong> Vi hanterar de flesta moment i vår egen verkstad, från konstruktion till slutlig ytbehandling.</li>
          <li><strong>Kostnadseffektivitet:</strong> Genom att minimera externa led kan vi erbjuda en effektiv process och konkurrenskraftiga priser.</li>
          <li><strong>Kvalitetsfokus:</strong> Vårt mål är att hög kvalitet ska vara tillgänglig för alla, oavsett kund eller projektstorlek.</li>
        </ul>

        <h2 style={{ fontSize: "1.8rem", marginBottom: "20px", color: "#004d66" }}>Några av våra kunder genom åren</h2>
        <ul style={{ textAlign: "left", display: "inline-block", fontSize: "1rem", lineHeight: "1.8", marginBottom: "30px" }}>
          <li>Postnord</li>
          <li>Volvo</li>
          <li>Försvarsmakten</li>
          <li>Wallhamn AB</li>
          <li>Småföretagare</li>
          <li>Privatpersoner</li>
        </ul>
      </div>

      {/* Center and style "Varmt välkommen!" */}
      <div style={{ textAlign: "center", marginTop: "30px" }}>
        <p style={{ fontSize: "1.2rem", fontWeight: "bold", margin: "20px 0", color: "#004d66" }}>
          Varmt välkommen!
        </p>
      </div>
    </div>
  );
};
